import { PageableInput } from '@allocab/allocab-commons-shared-types';
import { ShortDriver } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

export const DRIVERS_LIMIT = 10;

export type Input = Omit<PageableInput, 'offset' | 'limit'> & { limit?: number };

export const fetchDriversForVehicle = (vehicleId: string, input: PageableInput) =>
  driverApi.get<PageableInput, ShortDriver, 'list'>(`/v1/driver/vehicle/${vehicleId}`, input);

export const useFethDriversForVehiclePage = (vehicleId: string, input?: Input, pageNumber = 1) => {
  const limit = input?.limit ?? DRIVERS_LIMIT;
  const apiInput: PageableInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  return useQuery(
    queryKeys.user.fetchDriversForVehicle(vehicleId, apiInput),
    () => fetchDriversForVehicle(vehicleId, apiInput),
    {
      keepPreviousData: true,
    },
  );
};

export const prefetchDriversForVehiclePage = (vehicleId: string, input?: Input, pageNumber = 1) => {
  const limit = input?.limit ?? DRIVERS_LIMIT;
  const apiInput: PageableInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  queryClient.prefetchQuery(
    queryKeys.user.fetchDriversForVehicle(vehicleId, apiInput),
    () => fetchDriversForVehicle(vehicleId, apiInput),
    {
      staleTime: DEFAULT_CACHE_TIME,
    },
  );
};
